import { FormStatus, UpdateFormStatusResponse } from '../types';
import { FormCreateResponseApi } from '../types/formCreateApi';

const mapStatus = (status: string): FormStatus => {
  const normalized = status?.toLowerCase() || '';
  if (normalized === 'paused' || normalized === 'closed') {
    return normalized;
  }
  return 'published';
};

export const mapUpdateFormStatusResponse = (
  response: FormCreateResponseApi
): UpdateFormStatusResponse => ({
  formId: response.id,
  name: response.name,
  status: mapStatus(response.status),
  description: response.description,
  imageUrl: response.image_url,
  publicUrl: response.form_link,
  formVersion: response.version,
  createdAt: response.created_at,
  updatedAt: response.updated_at
});

export default mapUpdateFormStatusResponse;
